import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "flex w-full flex-col divide-y divide-gray-200 rounded-[0.65rem] border border-gray-200 shadow-md dark:divide-gray-700/75 dark:border-gray-700/75 dark:shadow-black/30" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "mb-px" }
const _hoisted_4 = ["aria-hidden"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menus, (menu, index) => {
      return (_openBlock(), _createElementBlock("li", {
        key: index,
        class: "bg-white first:rounded-t-[0.65rem] last:rounded-b-[0.65rem] dark:bg-slate-800"
      }, [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["flex w-full cursor-pointer items-center justify-between p-3 font-semibold outline-none transition-colors focus-visible:underline text-xl", 
          _ctx.activeIndex === index
            ? 'text-brand dark:text-gray-100'
            : 'text-gray-900 hover:text-brand dark:text-gray-100'
        ]),
          onClick: () => _ctx.handleClick(Number(index))
        }, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(menu.title), 1),
          _createVNode(_component_FontAwesomeIcon, {
            icon: _ctx.chevron,
            class: _normalizeClass(["-mr-1 ml-2 mt-px h-5 w-5 text-gray-600 transition-transform duration-200 dark:text-gray-300", _ctx.activeIndex === index && 'rotate-180']),
            "aria-hidden": "true"
          }, null, 8, ["icon", "class"])
        ], 10, _hoisted_2),
        _createElementVNode("div", {
          ref_for: true,
          ref: "tab",
          style: _normalizeStyle(_ctx.handleToggle(Number(index))),
          class: "max-h-0 overflow-hidden transition-all duration-300",
          "aria-hidden": _ctx.activeIndex !== index ? 'true' : 'false'
        }, [
          _renderSlot(_ctx.$slots, index)
        ], 12, _hoisted_4)
      ]))
    }), 128))
  ]))
}